<template>
  <div class="phone-edit">
    <div ref="phoneEditWrapper" class="phone-edit-container">
      <div class="phone-edit-h">
        <div class="phone-edit-title">
          <span class="text">{{ $t("Phones.EditPopup.Title") }}</span>
        </div>
        <div class="phone-edit-close" @click="emitTogglePhoneEdit2">
          <icon-base width="16" height="16" view-box="0 0 7 7" icon-name="times"><icon-times /></icon-base>
        </div>
      </div>
      <div class="phone-edit-b">
        <div class="input-w">
          <b-field :label="$t('Phones.EditPopup.RedirectPhones')">
            <b-select
              v-if="showRedirectPhoneDropdown"
              expanded
              data-testid="redirect-phone-select"
              :value="selectedPhone.RedirectPhone"
              @input="onRedirectPhoneChange"
            >
              <option v-for="option in redirectDestinationOptions" :value="option" :key="option">
                {{ option }}
              </option>
            </b-select>
            <b-input
              v-else
              v-model="selectedPhone.RedirectPhoneForUi"
              type="textarea"
              rows="3"
              data-testid="redirect-phone-textarea"
              :disabled="isRedirectPhoneLocked"
            ></b-input>
          </b-field>
        </div>
        <div class="input-w">
          <b-field :label="$t('Phones.EditPopup.PhoneForSms')">
            <b-input v-model="selectedPhone.PhoneForSms"></b-input>
          </b-field>
        </div>
        <div class="input-w" v-if="!isTwilioPhone">
          <b-field :label="$t('Phones.EditPopup.Expose.Label')">
            <b-select expanded :placeholder="$t('Phones.EditPopup.Expose.Label')" v-model="selectedPhone.Expose">
              <option :value="2">
                {{ $t("Phones.EditPopup.Expose.Caller") }}
              </option>
              <option :value="1">
                {{ $t("Phones.EditPopup.Expose.Maskyoo") }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="input-w" v-if="!isTwilioPhone">
          <b-field :label="$t('Phones.EditPopup.RecordOption.Label')">
            <b-select expanded :placeholder="$t('Phones.EditPopup.RecordOption.Label')" v-model="selectedPhone.RecordOption">
              <option :value="1">
                {{ $t("Phones.EditPopup.RecordOption.Caller") }}
              </option>
              <option :value="2">
                {{ $t("Phones.EditPopup.RecordOption.Callie") }}
              </option>
              <option :value="3">
                {{ $t("Phones.EditPopup.RecordOption.CallerAndCallie") }}
              </option>
              <option :value="4">
                {{ $t("Phones.EditPopup.RecordOption.DoNotRecordCalls")}}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="input-w" v-if="!isTwilioPhone">
          <b-field :label="$t('Phones.EditPopup.DialOption.Label')">
            <b-select expanded :placeholder="$t('Phones.EditPopup.DialOption.Label')" v-model="selectedPhone.DialOption">
              <option :value="1">
                {{ $t("Phones.EditPopup.DialOption.Parallel") }}
              </option>
              <option :value="2">
                {{ $t("Phones.EditPopup.DialOption.Hunt") }}
              </option>
              <option :value="3">
                {{ $t("Phones.EditPopup.DialOption.IVR") }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="input-w" style="display: none">
          <b-field :label="$t('Phones.EditPopup.Email')">
            <b-input v-model="selectedPhone.Email"></b-input>
          </b-field>
        </div>
        <div class="input-w" style="display: none">
          <b-field>
            <b-checkbox :value="isPhoneStatusActive" @input="onPhoneStatusChange" disabled>{{ $t("Phones.EditPopup.PhoneStatus") }}</b-checkbox>
          </b-field>
        </div>
        <div class="input-w">
          <b-field>
            <b-checkbox v-model="selectedPhone.CallCenter">{{ $t("Phones.EditPopup.CallCenter") }}</b-checkbox>
          </b-field>
        </div>
        <div class="input-w" v-if="selectedPhone.ChannelId || hasPhonesSyncRole">
          <b-field :label="$t('Phones.EditPopup.Channel')">
            <b-dropdown :value="selectedPhone.ChannelId" scrollable :max-height="300" aria-role="list" :disabled="!hasPhonesSyncRole" @change="onChannelChange">
              <template #trigger>
                <b-button>
                  <span class="dropdown-trigger-value">{{ selectedChannelName }}</span>
                  <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
                </b-button>
              </template>
              <b-dropdown-item custom aria-role="listitem">
                <b-input v-model="channelsSearch" :placeholder="$t('Search')" expanded />
              </b-dropdown-item>
              <b-dropdown-item v-for="channel in channelsFiltered" :key="channel.ChannelId" :value="channel.ChannelId" aria-role="listitem">
                <span>{{ channel.ChannelFieldName }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </b-field>
        </div>
        <div class="input-w" v-if="!isTwilioPhone">
          <b-field>
            <template #label>
              {{ $t('Phones.EditPopup.GreetingIn') }}
              <b-tooltip type="is-dark" :label="$t('Phones.EditPopup.GreetingInTooltip')" multilined>
                  <b-icon size="is-small" icon="help-circle-outline"></b-icon>
              </b-tooltip>
              <a href="#" class="upload-audio-file" @click="uploadAudioFile">{{ $t('Phones.EditPopup.UploadAudioFile.Label') }}</a>
            </template>
            <b-dropdown :value="selectedPhone.GreetingIn" scrollable :max-height="300" aria-role="list" :disabled="!prompts.length" @change="onGreetingInPromptChange">
              <template #trigger>
                <b-button>
                  <span class="dropdown-trigger-value">{{ selectedPhone.GreetingIn }}</span>
                  <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
                </b-button>
              </template>
              <b-dropdown-item custom aria-role="listitem">
                <b-input v-model="greetingInPromptsSearch" :placeholder="$t('Search')" expanded />
              </b-dropdown-item>
              <b-dropdown-item v-for="prompt in greetingInPromptsFiltered" :key="prompt.Value" :value="prompt.Value" aria-role="listitem">
                <span>{{ prompt.Text }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </b-field>
        </div>
        <div class="input-w" v-if="!isTwilioPhone">
          <b-field>
            <template #label>
              {{ $t('Phones.EditPopup.RingbackTone') }}
              <b-tooltip type="is-dark" :label="$t('Phones.EditPopup.RingbackToneTooltip')" multilined>
                  <b-icon size="is-small" icon="help-circle-outline"></b-icon>
              </b-tooltip>
              <a href="#" class="upload-audio-file" @click="uploadAudioFile">{{ $t('Phones.EditPopup.UploadAudioFile.Label') }}</a>
            </template>
            <b-dropdown :value="selectedPhone.RingbackTone" scrollable :max-height="300" aria-role="list" :disabled="!promptsRingbackTone.length" @change="onRingbackTonePromptChange">
              <template #trigger>
                <b-button>
                  <span class="dropdown-trigger-value">{{ selectedPhone.RingbackTone }}</span>
                  <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
                </b-button>
              </template>
              <b-dropdown-item custom aria-role="listitem">
                <b-input v-model="ringbackTonePromptsSearch" :placeholder="$t('Search')" expanded />
              </b-dropdown-item>
              <b-dropdown-item v-for="prompt in ringbackTonePromptsFiltered" :key="prompt.Value" :value="prompt.Value" aria-role="listitem">
                <span>{{ prompt.Text }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </b-field>
        </div>
        <div class="input-w" v-if="!isTwilioPhone">
          <b-field>
            <template #label>
              {{ $t('Phones.EditPopup.GreetingOut') }}
              <b-tooltip type="is-dark" :label="$t('Phones.EditPopup.GreetingOutTooltip')" multilined>
                  <b-icon size="is-small" icon="help-circle-outline"></b-icon>
              </b-tooltip>
              <a href="#" class="upload-audio-file" @click="uploadAudioFile">{{ $t('Phones.EditPopup.UploadAudioFile.Label') }}</a>
            </template>
            <b-dropdown :value="selectedPhone.GreetingOut" scrollable :max-height="300" aria-role="list" :disabled="!prompts.length" @change="onGreetingOutPromptChange">
              <template #trigger>
                <b-button>
                  <span class="dropdown-trigger-value">{{ selectedPhone.GreetingOut }}</span>
                  <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
                </b-button>
              </template>
              <b-dropdown-item custom aria-role="listitem">
                <b-input v-model="greetingOutPromptsSearch" :placeholder="$t('Search')" expanded />
              </b-dropdown-item>
              <b-dropdown-item v-for="prompt in greetingOutPromptsFiltered" :key="prompt.Value" :value="prompt.Value" aria-role="listitem">
                <span>{{ prompt.Text }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </b-field>
        </div>
        <div class="input-w">
          <b-field :label="$t('Phones.EditPopup.AnswerTime')">
            <b-select expanded :placeholder="$t('Phones.EditPopup.AnswerTime')" v-model="selectedPhone.AnswerTime">
              <option v-for="answerTimeOption in answerTimeOptions"
                    :value="answerTimeOption"
                    :key="answerTimeOption">
                {{ answerTimeOption }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="buttons">
          <div class="button-w">
            <b-button type="is-primary" expanded @click="updatePhone">{{ $t("Update") }}</b-button>
          </div>
          <div class="button-w">
            <b-button type="" class="is-nobackground" expanded @click="emitTogglePhoneEdit2">{{ $t("Cancel") }}</b-button>
          </div>
        </div>
      </div>
    </div>
    <div class="phone-edit-bg" @click="emitTogglePhoneEdit2"></div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { RefreshGridMode } from "@/models/leads/Lead";
import { ChannelArrayValue } from "@/models/campaigns/CRMChannel";
import { SelectListItem } from "@/models/MultiselectItem";
import { PhonesPageData } from "@/models/phones/PhonesPageData";
import { PhoneStatus, PhoneWithChannel } from "@/models/phones/PhoneWithChannel";
import { VirtualPhoneProvider } from "@/models/phones/VirtualPhoneProvider";
import { Result } from "@/models/Result";
import HelperService from "@/services/HelperService";
import PhonesApiService from "@/services/api/PhonesApiService";
import UploadAudio from "./UploadAudio.vue";
import IconBase from "../IconBase.vue";
import IconCaretDown from "../icons/IconCaretDown.vue";
import IconTimes from "../icons/IconTimes.vue";

const namespace = "phonesModule";

@Component({
  components: {
    IconBase,
    IconCaretDown,
    IconTimes,
  },
})
export default class PhonesGridContentEdit extends Vue {

  callForwardingNumber = "";
  emailForReferrals = "";
  mobileForSMS = "";
  numberDisplayed = "";

  emitTogglePhoneEdit2(): void {
    this.$emit("toggle-phone-edit2");
  }


  //#region Vuex getters and actions

  @Getter("phonesPageData", { namespace }) phonesPageData!: PhonesPageData;
  @Getter("selectedPhone", { namespace }) selectedPhone!: PhoneWithChannel;
  @Getter("hasPhonesSyncRole", { namespace: "mainModule" }) hasPhonesSyncRole!: boolean;
  @Action("setNeedToRefreshPhonesGrid", { namespace }) setNeedToRefreshPhonesGrid!: (needToRefreshPhonesGrid: RefreshGridMode) => void;

  //#endregion Vuex getters and actions


  //#region Properties

  channelsSearch = "";
  greetingInPromptsSearch = "";
  greetingOutPromptsSearch = "";
  ringbackTonePromptsSearch = "";
  phoneChannels: ChannelArrayValue[] = [];
  prompts: SelectListItem[] = [];
  promptsRingbackTone: SelectListItem[] = [];

  //#endregion Properties


  //#region Getters

  get answerTimeOptions(): number[] {
    return [...Array(88).keys()].map((i: number) => (i + 3) * 2);
  }

  get showRedirectPhoneDropdown(): boolean {
    return (this.phonesPageData.MaxRedirectPhones || 0) >= 2 && this.redirectDestinationOptions.length > 0;
  }

  get isRedirectPhoneLocked(): boolean {
    return this.phonesPageData.MaxRedirectPhones === 1 && this.selectedPhone.RedirectPhoneForUi !== "";
  }

  get redirectDestinationOptions(): string[] {
    const options = this.phonesPageData.RedirectDestinationOptions || [];
    const current = this.selectedPhone?.RedirectPhone;
    return current && options.indexOf(current) === -1 ? [...options, current] : options;
  }

  get channelsFiltered(): ChannelArrayValue[] {
    if (this.phoneChannels) {
      return this.phoneChannels.filter((i: ChannelArrayValue) => i.ChannelFieldName.toLowerCase().indexOf(this.channelsSearch.toLowerCase()) >= 0);
    } else {
      return [];
    }
  }

  get isPhoneStatusActive(): boolean {
    return this.selectedPhone.StatusId === PhoneStatus.Active;
  }

  get isTwilioPhone(): boolean {
    return this.selectedPhone.VirtualPhoneProviderId === VirtualPhoneProvider.Twilio;
  }

  get greetingInPromptsFiltered(): SelectListItem[] {
    if (this.prompts) {
      return this.prompts.filter((i: SelectListItem) => i.Text.toLowerCase().indexOf(this.greetingInPromptsSearch.toLowerCase()) >= 0);
    } else {
      return [];
    }
  }

  get greetingOutPromptsFiltered(): SelectListItem[] {
    if (this.prompts) {
      return this.prompts.filter((i: SelectListItem) => i.Text.toLowerCase().indexOf(this.greetingOutPromptsSearch.toLowerCase()) >= 0);
    } else {
      return [];
    }
  }

  get ringbackTonePromptsFiltered(): SelectListItem[] {
    if (this.prompts) {
      return this.promptsRingbackTone.filter((i: SelectListItem) => i.Text.toLowerCase().indexOf(this.ringbackTonePromptsSearch.toLowerCase()) >= 0);
    } else {
      return [];
    }
  }

  get selectedChannelName(): string {
    if(this.phoneChannels){
      if (this.selectedPhone.ChannelId) {
        const phoneChannel: ChannelArrayValue | undefined = this.phoneChannels.find((i: ChannelArrayValue) => i.ChannelId == this.selectedPhone.ChannelId);
        if (phoneChannel) {
          return phoneChannel.ChannelFieldName;
        }
      }
      else if(this.selectedPhone.AssetId){
        const assetId = `${this.selectedPhone.AssetId}:${this.selectedPhone.AssetTypeId}`;
        const phoneChannel: ChannelArrayValue | undefined = this.phoneChannels.find((i: ChannelArrayValue) => i.ChannelId == assetId);
        if (phoneChannel) {
          return phoneChannel.ChannelFieldName;
        }
      }
    }
   
    return "";
  }

  //#endregion Getters


  //#region Lifecycle

  mounted(): void {
    PhonesApiService.getPhonesChannels(this.selectedPhone.Id)
        .then((channels: ChannelArrayValue[]) => {
          this.phoneChannels = channels;
        });
    this.getPrompts();
  }

  //#endregion Lifecycle


  //#region Handlers

  onChannelChange(channelId: string): void {
    this.selectedPhone.ChannelId = channelId;
  }

  onPhoneStatusChange(active: boolean): void {
    this.selectedPhone.StatusId = active ? PhoneStatus.Active : PhoneStatus.InActive;
  }

  onGreetingInPromptChange(prompt: string): void {
    this.selectedPhone.GreetingIn = prompt;
  }

  onGreetingOutPromptChange(prompt: string): void {
    this.selectedPhone.GreetingOut = prompt;
  }

  onRingbackTonePromptChange(prompt: string): void {
    this.selectedPhone.RingbackTone = prompt;
  }

  onRedirectPhoneChange(phone: string): void {
    this.selectedPhone.RedirectPhone = phone;
    this.selectedPhone.RedirectPhoneForUi = phone;
  }

  //#endregion Handlers


  //#region Private methods

  getPrompts(): void {
    PhonesApiService.getPhonesPrompts(this.selectedPhone.CompanyId, false)
        .then((prompts: SelectListItem[]) => {
          this.prompts = prompts;
        });
    PhonesApiService.getPhonesPrompts(this.selectedPhone.CompanyId, true)
        .then((prompts: SelectListItem[]) => {
          this.promptsRingbackTone = prompts;
        });
  }

  updatePhone(): void {
    let loader = this.$loading.show({
      container: this.$refs.phoneEditWrapper
    });
    if (!this.selectedPhone.CampaignIdExternal) {
      if (this.selectedPhone.ChannelId) {
        this.selectedPhone.CampaignIdExternal = this.selectedPhone.ChannelId.toString();
      } else if (this.selectedPhone.AssetId && this.selectedPhone.AssetTypeId) {
        this.selectedPhone.CampaignIdExternal = `${this.selectedPhone.AssetId}:${this.selectedPhone.AssetTypeId}`;
      }
    }
    PhonesApiService.updatePhone(this.selectedPhone).then((result: Result) => {
      if (result.Success) {
        this.setNeedToRefreshPhonesGrid(RefreshGridMode.GridOnly);
        this.emitTogglePhoneEdit2();
      } else {
        HelperService.showError(result.Message)
      }
    }).finally(() => {
      loader.hide();
    });
  }

  uploadAudioFile(e: Event): void {
    e.preventDefault();
    this.$buefy.modal.open({
      parent: this,
      component: UploadAudio,
      hasModalCard: true,
      trapFocus: true,
      props: {
        companyId: this.selectedPhone.CompanyId,
      },
      events: {
        update: () => {
          this.getPrompts();
        },
      },
    });
  }

  //#endregion Private methods
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";
.phone-edit {
  position: fixed;
  z-index: 1600;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;

  .phone-edit-container {
    position: fixed;
    top: 0;
    right: 0;
    width: 477px;
    height: 100%;
    max-height: 100%;
    z-index: 10;
    transition: all 0.5s;
    transform: translateX(0);
    background: #f6f7fb;

    @media (max-width: 991px) {
      // width: 100%;
      height: 100%;
    }

    @media (max-width: 575px) {
      width: 100%;
    }

    .upload-audio-file {
      margin-inline-start: 1rem;
    }
  }

  .phone-edit-h {
    position: fixed;
    top: 0;
    left: 0;
    height: 56px;
    width: 100%;
    color: #fff;
    display: flex;
    align-items: center;
    padding: 12px 15px 13px 10px;
    background: linear-gradient(90deg, $primary 0%, #1ca8d9 52.75%);
    .phone-edit-close {
      padding: 5px;
      cursor: pointer;
      line-height: 0;
      margin-right: auto;
      transition: all 0.2s;
      &:hover {
        opacity: 0.8;
      }
      .icon-w {
        svg {
        }
      }
    }
    .phone-edit-title {
      display: flex;
      align-items: center;
      font-size: 21px;
      .icon-w {
        margin-left: 10px;
      }
    }
  }
  .phone-edit-b {
    position: fixed;
    top: 56px;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 22px 37px 40px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    @media (max-width: 575px) {
      padding: 10px 15px 30px;
    }
    .phone-edit-switches {
      padding: 20px 0;
      border-bottom: 1px solid $lightd;
      .switch {
        width: 100%;
        justify-content: space-between;
      }
    }
    .input-w {
      margin-bottom: 16px;
    }
    .textarea {
      height: 59px;
    }
    .dropdown {
      width: 100%;
      .dropdown-trigger {
        .button {
          width: 100%;
          .dropdown-trigger-value {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            text-align: left;
          }
        }
      }
      .dropdown-menu {
        width: 100% !important;
        max-width: 100%;
        .dropdown-content {
          width: 100%;
          max-width: 100%;
          .dropdown-item {
            max-width: 100%;
            span {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              display: block;
              max-width: 100%;
              width: 100%;
            }
          }
        }
      }
    }
    .buttons {
      margin: auto -10px 0;
      display: flex;
      padding: 0;
      @media (max-width: 575px) {
        margin: auto -8px 0;
      }
      .button-w {
        width: 50%;
        flex: 0 0 50%;
        padding: 0 10px;
        @media (max-width: 575px) {
          padding: 0 8px;
        }
      }
      .button {
        margin: 0;
        min-width: 0;
      }
    }
  }
  .phone-edit-bg {
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 9;
    transition: all 0.5s;
    background: rgba(0, 0, 0, 0.3);
  }
  .buttons {
    padding-bottom: 30px;
    .button {
      margin: 0;
    }
  }

  &.fade-enter-active,
  &.fade-leave-active {
    z-index: 101;
    transition: all 0.5s;
  }
  &.fade-enter,
  &.fade-leave-to,
  &.fade-leave-active {
    opacity: 1;
    .phone-edit-container {
      transform: translateX(100%);
    }
    .phone-edit-bg {
      opacity: 0;
    }
  }
  &.fade-enter {
  }
  &.active {
    z-index: 101;
    .phone-edit-container {
      // transform: translateX(0);
    }
  }
}

html[dir="ltr"] {
  .phone-edit {
    .phone-edit-h {
      padding: 12px 10px 13px 15px;
      .phone-edit-close {
        margin: 0 0 0 auto;
      }
    }
  }
}

@media (resolution: 120dpi) {
  .phone-edit .phone-edit-container {
    height: 125%;
    max-height: 125%;
  }
  .phone-edit .phone-edit-bg {
    height: 125%;
  }
}
</style>
